export default __webpack_public_path__ + "paddle_energy5a436d.svg";